'use strict'
const accordion = {
	el: {
		containers: document.querySelectorAll('.js-accordion'),
		btnShowMore: document.querySelector('.js-show-more')
	},

	fxToggleAccordion (el) {
		const nextEl = el.nextElementSibling
		$(nextEl).slideToggle(200)
		el.parentElement.classList.toggle('open')
	},

	fxShowElements(btn, container) {
		const list = container.querySelectorAll('.accordion__detail.d-none')

		list.forEach((el, i) => {
			if(i < 3) {
				$(el).fadeIn()
				el.classList.remove('d-none')
			}
			if(3 % list.length === 0) {
				btn.classList.add('d-none')
			}
		})
	},

	events () {
		for(const el of this.el.containers) {
			el.addEventListener('click', e => this.fxToggleAccordion(e.currentTarget))
		}
		if(!this.el.btnShowMore) return
		this.el.btnShowMore.addEventListener('click', e => this.fxShowElements(e.currentTarget, e.currentTarget.closest('.accordion')))
	},

	init () {
		if(this.el.containers.length === 0) return
		this.events ()
	}
}

accordion.init()